import {defineStore} from 'pinia'
import {checkDocument} from '@js/helpers.ts'

export const useThemeStore = defineStore('themeStore', {
    state: () => ({
        bodyOverflowLocks: 0,
    }),
    actions: {
        applyBodyOverflow() {
            if (!checkDocument()) return
            document.body.style.overflow = this.bodyOverflowLocks > 0 ? 'hidden' : ''
        },

        lockBodyOverflow() {
            this.bodyOverflowLocks++
            this.applyBodyOverflow()
        },

        unlockBodyOverflow() {
            this.bodyOverflowLocks = Math.max(0, this.bodyOverflowLocks - 1)
            this.applyBodyOverflow()
        },

        resetBodyOverflow() {
            this.bodyOverflowLocks = 0
            this.applyBodyOverflow()
        },

        setBodyOverflow(value) {
            if (value) {
                this.lockBodyOverflow()
            } else {
                this.unlockBodyOverflow()
            }
        },
    },
})
